import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { verifyAuth } from '../utils/auth';

const ProtectedRoute = ({ children }) => {
  const [isVerifying, setIsVerifying] = useState(true);
  const [isAuth, setIsAuth] = useState(false);

  useEffect(() => {
    const checkAuth = async () => {
      const authenticated = await verifyAuth();
      setIsAuth(authenticated);
      setIsVerifying(false);
    };

    checkAuth();
  }, []);

  if (isVerifying) {
    return (
      <div className="min-h-screen bg-gray-50 dark:bg-gray-950 flex items-center justify-center">
        <p className="text-xl text-gray-600 dark:text-gray-400">Verifying authentication...</p>
      </div>
    );
  }

  return isAuth ? children : <Navigate to="/login" replace />;
};

export default ProtectedRoute;
